import * as Icons from '@mui/icons-material';
import { CheckCircleOutline } from '@mui/icons-material';
import {
    Card,
    Typography,
    CardActionArea,
    CardContent,
    SvgIcon,
    Alert
  } from '@mui/material';
import { cardDialogStyle } from 'src/careflow/helpers/workflowStyle';

interface DispositionCardProps {
  data: any,
  selected: string,
  handler: any,
  i18n: any
};
  
const DispositionCard = ({
  data,
  selected,
  handler,
  i18n
}: DispositionCardProps) => {
  const {
    code = null, 
    title = null, 
    subTitle = null, 
    icon = null, 
    iconColor = null,
    errorMessage = null,
    isValid = false
  } = data ?? {};
  const Icon = Icons[icon] as typeof SvgIcon;
  const msgError = errorMessage ? errorMessage : i18n('errorMessages.defaultWorkflow', 'crs');
  const disabledCard =  isValid ? false : true; 

  return (
    <Card>
      <CardActionArea
        onClick={handler}
        data-active={selected === code ? '' : undefined}
        sx={cardDialogStyle}
        disableRipple={true}
        disabled={disabledCard}
      >
        <CardContent 
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <CheckCircleOutline
            className="focus-icon"
            sx={{ 
              top: '5px', 
              right: '5px',
              color: '#00AB55', 
              position: 'absolute',
              width: 20, 
              height: 20
            }}   
          />
          {icon && 
            <Icon 
              sx={{ 
                ...iconColor && {color: iconColor}, 
                width: 60, 
                height: 60,
              }} 
            />
          }
          <Typography variant="h6" component="div" textAlign='center'>
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary" textAlign='center'>
            {subTitle}
          </Typography>
          {disabledCard && 
            <Alert 
              severity="error" 
              sx={{ 
                lineHeight: 'normal', 
                marginTop: '4px',
                p: '0 0 0 4px',
              }}
            >
              {msgError}
            </Alert>
          }
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DispositionCard;